import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { AccessUsuarioCexvegGuard, AccessUsuarioExternoGuard, AccessMisDatosGuard } from './_classes/access.guard';
import { BulkCasListComponent } from './bulkcas/bulkcas-list.component';
import { LoginCASComponent } from './login/login-cas.component';
import { LoginDevComponent } from './login/login-dev.component';
import { UsuarioscexvegEditComponent } from './usuarioscexveg/usuarioscexveg-edit.component';
import { UsuarioscexvegListComponent } from './usuarioscexveg/usuarioscexveg-list.component';
import { UsuariosexternosEditComponent } from './usuariosexternos/usuariosexternos-edit.component';
import { UsuariosexternosListComponent } from './usuariosexternos/usuariosexternos-list.component';
import { UsuariosMigracionListComponent } from './usuariosmigracion/usuariosmigracion-list.component';
import { ActionGuard, LoginGuard, LogoutGuard } from '../../core/_infrastructure/classes/guards/main.guard';

const usuariosRoutes: Routes = [
    {
        path: 'mantenimiento/usuarios/login',
        component: LoginCASComponent,
        data: {
            breadcrumb: 'Login',
            menu0: 'GLOBAL',
            //menu0: 'MANTENIMIENTO',
            //menu1: 'Usuarios'
        },
    },

    {
        path: 'mantenimiento/usuarios/logindev',
        component: LoginDevComponent,
        data: {
            breadcrumb: 'Login Desarrollo',
            menu0: 'GLOBAL',
            //menu0: 'MANTENIMIENTO',
            //menu1: 'Usuarios''
        },
    },

    //Usuarios CEXVEG
    {
        path: 'mantenimiento/usuarios/usuarioscexveg',
        data: {
            breadcrumb: 'Usuarios CEXVEG',
            menu0: 'GLOBAL',
            //menu0: 'MANTENIMIENTO',
            //menu1: 'Usuarios'
        },
        children: [
            {
                path: '',
                component: UsuarioscexvegListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.USUARIOS_CEXVEG,
                },
            },
            {
                path: 'edit/:id',
                component: UsuarioscexvegEditComponent,
                canActivate: [LoginGuard(), ActionGuard(), AccessUsuarioCexvegGuard()],
                data: {
                    breadcrumb: 'Editar Usuario Cexveg',
                    actionCode: EnumCodigosTwTcAcciones.USUARIOS_CEXVEG,
                },
            },
            {
                path: 'create',
                component: UsuarioscexvegEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Usuario Cexveg',
                    actionCode: EnumCodigosTwTcAcciones.USUARIOS_CEXVEG,
                },
            },
        ],
    },

    //Usuarios Externos
    {
        path: 'mantenimiento/usuarios/usuariosexternos',
        data: {
            breadcrumb: 'Usuarios Externos',
            menu0: 'GLOBAL',
            //menu0: 'MANTENIMIENTO',
            //menu1: 'Usuarios'
        },
        children: [
            {
                path: '',
                component: UsuariosexternosListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.USUARIOS_EXTERNOS,
                },
            },
            {
                path: 'edit/:id',
                component: UsuariosexternosEditComponent,
                canActivate: [LoginGuard(), ActionGuard(), AccessUsuarioExternoGuard()],
                data: {
                    breadcrumb: 'Editar Usuario Externo',
                    actionCode: EnumCodigosTwTcAcciones.USUARIOS_EXTERNOS,
                },
            },
            {
                path: 'create',
                component: UsuariosexternosEditComponent,
                canActivate: [LogoutGuard()],

                data: {
                    breadcrumb: 'Nuevo Usuario Externo',
                },
            },
            {
                path: 'editmisdatos/:id',
                component: UsuariosexternosEditComponent,
                canActivate: [LoginGuard(), ActionGuard(), AccessMisDatosGuard()],
                data: {
                    breadcrumb: 'Editar Usuario Externo',
                    actionCode: EnumCodigosTwTcAcciones.MISDATOS_USREXTERNO,
                },
            },
        ],
    },

    //Usuarios Migración
    {
        path: 'mantenimiento/usuarios/usuariosmigracion',
        data: {
            breadcrumb: 'Usuarios Migración',
            menu0: 'GLOBAL',
            //menu0: 'MANTENIMIENTO',
            //menu1: 'Usuarios'
        },
        children: [
            {
                path: '',
                component: UsuariosMigracionListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.USUARIOS_MIGRACION,
                },
            },
        ],
    },

    //Bulk usuarios CAS
    {
        path: 'mantenimiento/usuarios/bulkcas',
        data: {
            breadcrumb: 'Bulk',
            menu0: 'GLOBAL',
            //menu0: 'MANTENIMIENTO',
            //menu1: 'Usuarios'
        },
        children: [
            {
                path: '',
                component: BulkCasListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(usuariosRoutes)],
    exports: [RouterModule],
})
export class UsuariosRoutingModule {}
